module.exports = __webpack_public_path__ + "img/habitat-dome.c3c43812.svg";